import React from 'react'
import {
  CFSelect,
  CFView,
  CFImage,
  DefaultScreen,
  MobileScreen,
} from 'components'
import { orderDelivery } from 'images'
import { dispatch } from 'store'

export default () => {
  return (
    <CFSelect selector={dispatch.restaurant.getSelectedLocationId}>
      {locationId => (
        <CFView>
          <MobileScreen>
            <a
              href="https://www.ubereats.com/ca/store/uncle-sushi-1122-5th-avenue/OnC10E0BVbCgWDCx-cEWAg?diningMode=DELIVERY&sc=SEARCH_SUGGESTION"
              target="_blank"
            >
              <CFView hover>
                <CFImage src={orderDelivery} maxWidth="270px" alt="About" />
              </CFView>
            </a>
          </MobileScreen>
          <DefaultScreen>
            <a
              href="https://www.ubereats.com/ca/store/uncle-sushi-1122-5th-avenue/OnC10E0BVbCgWDCx-cEWAg?diningMode=DELIVERY&sc=SEARCH_SUGGESTION"
              target="_blank"
            >
              <CFView hover>
                <CFImage
                  src={orderDelivery}
                  w="100%"
                  maxWidth="250px"
                  alt="About"
                />
              </CFView>
            </a>
          </DefaultScreen>
        </CFView>
      )}
    </CFSelect>
  )
}
